defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewInvite/Invitation',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'Shared/Framework/Ensighten/Scripts/Ensighten',
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/Params',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardContent',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/PostCard'
  ],
  function (m, Ensighten, Params, PlayTogetherApi, Utils, CardContent, CtaButton, PostCard) {
    var Invitation = {
      controller: function ({ controller }) {
        Object.assign(this, controller);

        this.isFromCreationFlow = Params.extract('fromCreationFlow') || false;
        this.invitationCardDictionary = this.rootDictionary.get.bind({ prefix: 'ViewInvite/InvitationCard/' });
        this.shareOptionsDictionary = this.rootDictionary.get.bind({ prefix: 'ViewInvite/InvitationCard/ShareOptions/' });
        this.copiedInviteLink = m.prop(false);
        this.QrCodeImage = m.prop(null);
        this.loadingQrCodeImage = m.prop(true);

        PlayTogetherApi.getQRCode(this.clubModelFields().linkClubId()).then((response) => {
          this.QrCodeImage(response.Content);
          this.loadingQrCodeImage(false);
          m.redraw();
        }).catch(() => {
          this.loadingQrCodeImage(false);
          m.redraw();
        });

        this.copyInviteLink = () => {
          this.copiedInviteLink(true);
          setTimeout(() => {
            this.copiedInviteLink(false);
          }, 3000);

          const $inviteLinkInput = document.querySelector('.play-together-invitation__invitation-link');
          $inviteLinkInput.focus();
          $inviteLinkInput.select();
          $inviteLinkInput.setSelectionRange(0, 99999);
          if (navigator) {
            navigator.clipboard.writeText($inviteLinkInput.value);
          } else {
            document.execCommand('copy');
          }

          Ensighten.pushGaEvent('spil_sammen', 'inviter_medlem', 'linket_kopieret');
        };

        this.trackShareOptions = (shareOption) => {
          return () => {
            Ensighten.pushGaEvent('spil_sammen', 'inviter_medlem', shareOption.toLocaleLowerCase());
          };
        };

        if (this.isFromCreationFlow) {
          Ensighten.pushGaEvent('spil_sammen', 'create_club', 'inviter', null, true);
        }
      },
      view: function (controller) {
        const shareOptions = () => {
          const option = ({ icon, label, href }) => {
            return m('a.play-together-invitation__share-item', {
              target: '_blank',
              onclick: controller.trackShareOptions(label),
              href
            }, [
              m('.play-together-invitation__share-item-icon-wrapper',
                m('svg.play-together-invitation__share-item-icon', {
                  class: `play-together-invitation__share-item-icon--${icon}`
                }, m('use', {
                  href: `/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/SocialIcons.svg#${icon}`
                }))
              ),
              m('.play-together-invitation__share-item-label', label)
            ]);
          };
          const messenger = option({
            icon: 'messenger',
            label: controller.shareOptionsDictionary('Messenger/Label'),
            href: `fb-messenger://share/?link=${controller.clubModelFields().inviteLink()}&app_id=123456789`
          });

          const facebook = option({
            icon: 'facebook',
            label: controller.shareOptionsDictionary('Facebook/Label'),
            href: `https://www.facebook.com/sharer/sharer.php?u=${controller.clubModelFields().inviteLink()}`
          });

          const email = option({
            icon: 'email',
            label: controller.shareOptionsDictionary('Email/Label'),
            href: `mailto:?subject=${controller.shareOptionsDictionary('Email/EmailSubject')}&body=${controller.shareOptionsDictionary('Email/EmailBody', { link: controller.clubModelFields().inviteLink() })}`
          });

          const sms = option({
            icon: 'sms',
            label: controller.shareOptionsDictionary('Sms/Label'),
            href: `sms:?&body=${encodeURIComponent(controller.shareOptionsDictionary('Sms/SmsBody', { link: controller.clubModelFields().inviteLink() }))}`
          });

          let options = [facebook, email];

          if (Utils.isMobile()) {
            options = [messenger, facebook, sms, email];
          }

          return m('.play-together-invitation__share-options', options);
        };

        const invitationCard = m('.play-together-invitation-card', [
          m('.play-together-invitation__header', controller.invitationCardDictionary('Title')),
          m('.play-together-invitation__qr-wrapper', [
            controller.loadingQrCodeImage() ?
              m('.play-together-invitation__qr-loader') :
              m('.play-together-invitation__qr-image', m.trust(controller.QrCodeImage())),
            m('.play-together-invitation__qr-id', controller.clubModelFields().linkClubId())
          ]),
          m('.play-together-invitation__link-clipboard', {
            onclick: controller.copyInviteLink
          }, [
            m('.play-together-invitation__link-clipboard-label', controller.invitationCardDictionary('ClipboardLabel')),
            m('.play-together-invitation__link-clipboard-value', controller.clubModelFields().linkClubId()),
            m('.play-together-invitation__clipboard-copied-message', {
              class: controller.copiedInviteLink() ? 'play-together-invitation__clipboard-copied-message--visible' : ''
            }, controller.invitationCardDictionary('ClipboardCopiedMessage')),
            m('input.play-together-invitation__invitation-link', {
              hidden: true,
              readonly: true,
              value: controller.clubModelFields().inviteLink()
            }),
            m('.play-together-invitation__link-clipboard-button', {
              class: controller.copiedInviteLink() ? 'play-together-invitation__link-clipboard-button--copied' : ''
            },
            m('svg.play-together-invitation__link-clipboard-button-icon', m('use', {
              href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/SocialIcons.svg#link'
            }))
            )
          ]),
          m('.play-together-invitation__description', m.trust(controller.invitationCardDictionary('Description'))),
          shareOptions()
        ]);

        const $content = [
          invitationCard,
          PostCard({
            icon: 'spilSammen_logo_icon',
            type: 'promote',
            title: controller.dictionary('HowItWorksCard/Title'),
            description: controller.dictionary('HowItWorksCard/Description'),
            $footer: CtaButton({
              text: controller.dictionary('HowItWorksCard/Button'),
              href: controller.navigationPaths.guidePage,
              options: ['small', 'transparent', 'white']
            })
          })
        ];

        return CardContent({
          className: 'play-together-invitation-wrapper',
          $content,
          $footer: CtaButton({
            text: controller.dictionary('GoToClubButton'),
            options: ['primary'],
            href: `${controller.navigationPaths.clubPage}?klubId=${controller.clubId()}`
          })
        });
      }
    };

    // Public functions:
    return Invitation;
  });
